import registry from '../seo/seoRegistry.json';
import { normalize } from '../components/website/sections/SwatchFilter';

const API = process.env.REACT_APP_BACKEND_URL;
const PRIVATE = [...(registry.noindex_prefixes || []), '/search', '/cart'];
const stem = (t) => (t.length > 3 && t.endsWith('s') && !t.endsWith('ss') ? t.slice(0, -1) : t);
const toks = (s) => normalize(s).replace(/<[^>]+>/g, ' ').split(/[^a-z0-9]+/).filter(Boolean).map(stem);

// Code-built public pages from the SEO registry (warranty, measuring, guides, partners…)
const REGISTRY_PAGES = Object.entries(registry.pages || {})
  .filter(([path]) => !PRIVATE.some((p) => path.startsWith(p)))
  .map(([path, v]) => ({ path, title: (v.title || '').split(' | ')[0], description: v.description || '', _t: toks(`${v.title} ${v.description}`) }));

const localPages = (q) => {
  const qt = toks(q);
  if (!qt.length) return [];
  const inTitle = (p) => qt.every((t) => toks(p.title).some((w) => w.startsWith(t)));
  return REGISTRY_PAGES.filter((p) => qt.every((t) => p._t.some((w) => w.startsWith(t))))
    .map((p) => ({ ...p, titleHit: inTitle(p) }));
};

const cache = new Map();

export const searchSite = async (q, signal) => {
  const key = normalize(q.trim());
  if (cache.has(key)) return cache.get(key);
  const res = await fetch(`${API}/api/search?q=${encodeURIComponent(q.trim())}`, { signal }).then((r) => r.json());
  const seen = new Set([...res.products, ...res.pages].map((d) => d.path));
  const extra = localPages(q).filter((p) => !seen.has(p.path)).map(({ _t, ...p }) => p);
  const isProduct = (p) => p.path.startsWith('/products/') || p.path.startsWith('/shades/');
  // Pages whose title matches (e.g. "Warranty & Service") lead their group
  const merge = (server, local) => [...local.filter((p) => p.titleHit), ...server, ...local.filter((p) => !p.titleHit)].map(({ titleHit, ...p }) => p).slice(0, 8);
  const out = {
    ...res,
    products: merge(res.products, extra.filter(isProduct)),
    pages: merge(res.pages, extra.filter((p) => !isProduct(p))),
  };
  if (cache.size > 50) cache.delete(cache.keys().next().value);
  cache.set(key, out);
  return out;
};

export const hasResults = (r) => r && (r.products.length || r.pages.length || r.fabrics.length || r.collections.length);
